import GeoFencingView from "./GeoFencingView";

const GeoFencing = () => {
  return <GeoFencingView />;
};

export default GeoFencing;
